// extracted by mini-css-extract-plugin
export default {"wrapper":"Details_wrapper__hCQ9s","title":"Details_title__2Q4z2","flex":"Details_flex__2gcXA","code":"Details_code__eQydG","box":"Details_box__XXShM"};